import type { Can } from 'providers/casl'

export const onYieldbirdWrapperAgentAccess = (can: Can): void => {
  can('access', 'YieldbirdWrapperAgentPage')
}
